import { createLocalStorage } from "./localStorage";

/**
 *
 * @param key
 * @param items
 * @returns
 */
export function useBookmark<T extends { id: string }>(key: string): BookmarkPrimitive<T> {
	const [bookmarks, setBookmarks] = createLocalStorage<Set<string>>({
		key,
		onSerialize(value) {
			return JSON.stringify(Array.from(value));
		},
		onDeserialize(value) {
			return new Set((value && JSON.parse(value)) || []);
		},
	});

	const handleBookmark = (item: T) => {
		const books = bookmarks();
		const bookmarkList = new Set(books);

		if (!item.id) {
			console.warn("No ID provided for bookmarking");
			return;
		}

		if (books.has(item.id)) {
			bookmarkList.delete(item.id);
		} else {
			bookmarkList.add(item.id);
		}

		setBookmarks(bookmarkList);
	};

	const hasBookmarked = (value: string | T) => {
		if (typeof value === "string") {
			return bookmarks().has(value);
		}

		if ("id" in value) {
			return bookmarks().has(value.id);
		}

		return false;
	};

	return {
		bookmarks,
		bookmark: handleBookmark,
		hasBookmarked,
	};
}

export interface BookmarkPrimitive<T> {
	bookmarks: () => Set<string>;
	bookmark: (item: T) => void;
	hasBookmarked: (id: string | T) => boolean;
}
